export interface DifficultySettings {
  obstacleVelocity: number;
  spawnDelay: number;
  gapSize: number;
}

export class DifficultyManager {
  private readonly base: DifficultySettings = {
    obstacleVelocity: 170,
    spawnDelay: 1550,
    gapSize: 220,
  };

  getSettings(score: number): DifficultySettings {
    const level = Math.min(12, Math.floor(score / 3));

    return {
      obstacleVelocity: this.base.obstacleVelocity + level * 11,
      spawnDelay: Math.max(1050, this.base.spawnDelay - level * 42),
      gapSize: Math.max(156, this.base.gapSize - level * 5),
    };
  }
}
